import { KText } from '@/ui-library/components/text';
import { Center, Flex, Icon, Image } from '@chakra-ui/react';
import { FaPlus } from 'react-icons/fa';

export const IconButton = ({
  icon = FaPlus,
  text = 'Choose template',
  iconProps = {},
  iconContainerProps = {},
  textProps = {},
  isImageUrl = false,
  bg = 'secondary-50',
  ...props
}) => {
  return (
    <Flex as="button" gap="6px" alignItems="center" {...props}>
      <Center
        width="20px"
        height="20px"
        borderRadius="full"
        bg={bg}
        {...iconContainerProps}
      >
        {icon &&
          (isImageUrl ? (
            <Image
              src={icon}
              width="8px"
              height="8px"
              objectFit="contain"
              {...iconProps}
            />
          ) : (
            <Icon
              as={icon}
              color="primary-500"
              width="8px"
              height="8px"
              {...iconProps}
            />
          ))}
      </Center>
      <KText
        whiteSpace="nowrap"
        size="sm-medium"
        color="primary-500"
        {...textProps}
      >
        {text}
      </KText>
    </Flex>
  );
};
